"use strict";
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var navId = 'navigation';
var expanderClass = 'js-expand';

function toggleNav(event) {
    $('body').toggleClass('js-nav-open');
    return event.preventDefault();
}

function addExpander(container, expanderClass) {
    var html = '<button class="'+ expanderClass +'"><span class="anta_sr">Expand</span></button>';
    container.append( $(html) );
}

function expandSubnav(event) {
    $(event.target).closest('li').toggleClass('js-expanded');
    event.preventDefault();
}

$(function() {
    $('#' + navId).on('click', toggleNav);
    $('#main-nav').find('.children').parent().children('a').each(function () {
        addExpander( $(this), expanderClass );
    });
    $('body').on('click', '.' + expanderClass, expandSubnav);
});
